<div [class]="'pretty ' + getType()">
  <ng-content></ng-content>
  <div [class]="'state ' + getSuccessState()">
      <label>{{label}}</label>
  </div>
</div>
